import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, } from "chart.js";
import { Bar } from "react-chartjs-2";
import "./BarChart.css"
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);
function BarChart({ title = "", yAxisLabel = "", showYAxis = false, height, data: values = [0, 0, 0, 0, 0] }) {
    const data = {
        labels: ["0-20", "20-40", "40-60", "60-80", "80-100"],
        datasets: [
            {
                data: values,
                backgroundColor: [
                    "#4DABF7", // bleu (0-20)
                    "#845EF7", // violet
                    "#9775FA", // violet clair
                    "#FFA94D", // orange
                    "#F76707", // orange fort (80-100)
                ],
                borderRadius: 10, // radius des barres
                barThickness: 13, // epaisseur des barres
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                display: false,
            },
        },

        scales: {
            y: {
                display: !!yAxisLabel && showYAxis,
                grid: {
                    display: false,
                },
                ticks: {
                    display: showYAxis,
                    stepSize: 5,
                },
                beginAtZero: true,
            },

            x: {
                grid: {
                    display: false, // ❌ enlève lignes verticales
                },
                ticks: {
                    callback: function (value, index) {
                        const labels = [
                            "0–20%",
                            "20–40%",
                            "40–60%",
                            "60–80%",
                            "80–100%",
                        ];
                        return labels[index];
                    },
                },
            },
        },
    };

    return (
        <div>
            {title && <div className="chart-title">{title}</div> }
            {showYAxis && yAxisLabel && (
                <div className="chart-y-label">{yAxisLabel}</div>
            )}
            <div style={{height : height}}>
                <Bar data={data} options={options} />
            </div>

        </div>

    );
}

export default BarChart;